import { TrustPartners, Typography, useImageUrlFromCdn } from '@/components'
import { Carousel, TestimonialCard } from '@surein/ui'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { TestimonialCardWrapper, TestimonialGrid } from './styles'

const TextAlignTypography = styled(Typography)`
  text-align: center;
  margin-top: 8px;
`

interface TestimonialSectionProps {
  isMobile: boolean
}

interface Testimonial {
  title: string
  subtitle: string
  text: string
  imageUrl: string
}

export const TestimonialSection = ({ isMobile }: TestimonialSectionProps) => {
  const { t } = useTranslation()
  const testimonials = t('recommendationTestimonials', {
    returnObjects: true,
  }) as Testimonial[]
  const { imageUrlFromCdn } = useImageUrlFromCdn({
    type: 'webp',
    fallbackType: 'jpg',
  })

  return (
    <>
      <div className="flex flex-col items-center justify-center px-4 gap-6 mt-4">
        <TextAlignTypography bold variant="h3">
          {t('earnedTheTrust')}
        </TextAlignTypography>
        <TrustPartners
          hide={{
            ssl: isMobile,
          }}
          mode="dark"
        />
      </div>
      <TestimonialGrid>
        {isMobile ? (
          <Carousel startIndex={1}>
            {testimonials.map((testimonial: Testimonial) => (
              <TestimonialCardWrapper key={testimonial.title}>
                <TestimonialCard
                  title={testimonial.title}
                  subtitle={testimonial.subtitle}
                  text={testimonial.text}
                  imageUrl={imageUrlFromCdn(testimonial.imageUrl)}
                />
              </TestimonialCardWrapper>
            ))}
          </Carousel>
        ) : (
          testimonials.map((testimonial: Testimonial) => (
            <TestimonialCardWrapper key={testimonial.title}>
              <TestimonialCard
                title={testimonial.title}
                subtitle={testimonial.subtitle}
                text={testimonial.text}
                imageUrl={imageUrlFromCdn(testimonial.imageUrl)}
              />
            </TestimonialCardWrapper>
          ))
        )}
      </TestimonialGrid>
    </>
  )
}
